import produce from 'immer';
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
function convertMinutesToHourAndMinutes(minutes) {
  const hour = Math.floor(minutes / 60);
  const minute = minutes % 60;
  return {
    hour,
    minute
  };
}
export default class TimeOfDay extends createImmutableObjectClass({
  hour: 0,
  minute: 0
}) {
  updateTime(minutes) {
    const {
      hour,
      minute
    } = convertMinutesToHourAndMinutes(minutes);
    return produce(this, draft => {
      draft.hour = hour;
      draft.minute = minute;
    });
  }
  getMinutes() {
    return this.hour * 60 + this.minute;
  }
}